const staff_emails = [
`appysch@intrinsicschools.org`, 
`12spanish@intrinsicschools.org`, 
`8thmathplaceholder@intrinsicschools.org`, 
`9thbioph@intrinsicschools.org`, 
`9thmathsped@intrinsicschools.org`, 
`adavis1@intrinsicschools.org`, 
`draupp@intrinsicschools.org`, 
`iabid@intrinsicschools.org`, 
`ktaylor@intrinsicschools.org`, 
`mstanley@intrinsicschools.org`, 
`rmanuel@intrinsicschools.org`, 
`sireland@intrinsicschools.org`, 
`stzoumas@intrinsicschools.org`, 
`tbrusveen@intrinsicschools.org`, 
`11seminar@intrinsicschools.org`, 
`adamroth@intrinsicschools.org`, 
`alexbutler@intrinsicschools.org`, 
`dquiles@intrinsicschools.org`, 
`Dwillingham@intrinsicschools.org`, 
`dsouthard@intrinsicschools.org`, 
`emanelnatour@intrinsicschools.org`, 
`jlaureano@intrinsicschools.org`, 
`jespinoza@intrinsicschools.org`, 
`laniedmonds@intrinsicschools.org`, 
`lquinn@intrinsicschools.org`, 
`lucyforeman@intrinsicschools.org`, 
`mhersch@intrinsicschools.org`, 
`11thmath@intrinsicschools.org`, 
`math1011@intrinsicschools.org`, 
`8thmath@intrinsicschools.org`, 
`msweeten2@intrinsicschools.org`, 
`nmayer@intrinsicschools.org`, 
`nikalofton@intrinsicschools.org`, 
`nfriedman@intrinsicschools.org`, 
`rmadi@intrinsicschools.org`, 
`rpartisala@intrinsicschools.org`, 
`rtraubert@intrinsicschools.org`, 
`rkellar@intrinsicschools.org`, 
`rshelton@intrinsicschools.org`, 
`schamboullides@intrinsicschools.org`, 
`sschuler@intrinsicschools.org`, 
`tscranton@intrinsicschools.org`, 
`twilliams@intrinsicschools.org`, 
`wbittner@intrinsicschools.org`, 
`zdaugherty@intrinsicschools.org`, 
`akloss@intrinsicschools.org`, 
`akackley@intrinsicschools.org`, 
`awalton@intrinsicschools.org`, 
`agonzalez7@intrinsicschools.org`, 
`agodel@intrinsicschools.org`, 
`avivarosenberg@intrinsicschools.org`, 
`bweisberg@intrinsicschools.org`, 
`bmiller@intrinsicschools.org`, 
`bfernandez2@intrinsicschools.org`, 
`cbranam@intrinsicschools.org`, 
`ccrittendon@intrinsicschools.org`, 
`cmiranda2@intrinsicschools.org`, 
`cjohnson@intrinsicschools.org`, 
`dgates@intrinsicschools.org`, 
`dsage@intrinsicschools.org`, 
`davidarroyo@intrinsicschools.org`, 
`dconnor@intrinsicschools.org`, 
`elviarojas@intrinsicschools.org`, 
`erikagonzalez@intrinsicschools.org`, 
`hlambert@intrinsicschools.org`, 
`ilosoff@intrinsicschools.org`, 
`jacobkahn@intrinsicschools.org`, 
`jdelacruz@intrinsicschools.org`, 
`jtimms.ssg@gmail.com`, 
`jmadonna@intrinsicschools.org`, 
`jmagar@intrinsicschools.org`, 
`knelson@intrinsicschools.org`, 
`kaydelanger@intrinsicschools.org`, 
`kbower@intrinsicschools.org`, 
`kjezior@intrinsicschools.org`, 
`kkruger@intrinsicschools.org`, 
`lwilliams@intrinsicschools.org`, 
`lmay@intrinsicschools.org`, 
`lunchstaff@intrinsicschools.org`, 
`mbehnke@intrinsicschools.org`, 
`masonmccarl@intrinsicschools.org`, 
`mpietz@intrinsicschools.org`, 
`mmachala@intrinsicschools.org`, 
`ntabet@intrinsicschools.org`, 
`narranda@intrinsicschools.org`, 
`pleifer@intrinsicschools.org`, 
`parzatemorris@intrinsicschools.org`, 
`slee@intrinsicschools.org`, 
`smurphy@intrinsicschools.org`, 
`smoreno@intrinsicschools.org`, 
`sseitz@intrinsicschools.org`, 
`scardon@intrinsicschools.org`, 
`tmorrow@intrinsicschools.org`, 
`tjordan@intrinsicschools.org`, 
`unikaspaulding@intrinsicschools.org`, 
`ykaslow@intrinsicschools.org`, 
`asalerno@intrinsicschools.org`, 
`aplatt@intrinsicschools.org`, 
`aybarra@intrinsicschools.org`, 
`aevans@intrinsicschools.org`, 
`aokonta@intrinsicschools.org`, 
`aatkins@intrinsicschools.org`, 
`audreyfrost@intrinsicschools.org`, 
`aguzman@intrinsicschools.org`, 
`btaylor2@intrinsicschools.org`, 
`bcampbell@intrinsicschools.org`, 
`brendavargastapia@intrinsicschools.org`, 
`brianavillagrana@intrinsicschools.org`, 
`brobinson1@intrinsicschools.org`, 
`cacosta@intrinsicschools.org`, 
`cmurillo@intrinsicschools.org`, 
`civicsbusiness@intrinsicschools.org`, 
`cjakubiszyn@intrinsicschools.org`, 
`dbausch@intrinsicschools.org`, 
`dhenderson@intrinsicschools.org`, 
`dberry@intrinsicschools.org`, 
`dfisher@intrinsicschools.org`, 
`gbaumberger@intrinsicschools.org`, 
`hrusso@intrinsicschools.org`, 
`hmoiseev@intrinsicschools.org`, 
`hannahroth@intrinsicschools.org`, 
`hlombard@intrinsicschools.org`, 
`isabelpetkov@intrinsicschools.org`, 
`iramirez@intrinsicschools.org`, 
`jtempone@intrinsicschools.org`, 
`jjohnson@intrinsicschools.org`, 
`jordanarnold@intrinsicschools.org`, 
`jowens@intrinsicschools.org`, 
`jlittle@intrinsicschools.org`, 
`jgardner@intrinsicschools.org`, 
`jgonder@intrinsicschools.org`, 
`kPointer@intrinsicschools.org`, 
`lhudson@intrinsicschools.org`, 
`mculhane@intrinsicschools.org`, 
`marcussweeten@intrinsicschools.org`, 
`mjones3@intrinsicschools.org`, 
`mlubowsky@intrinsicschools.org`, 
`mcabell@intrinsicschools.org`, 
`neenahwiggins@intrinsicschools.org`, 
`nwilliams@intrinsicschools.org`, 
`plong@intrinsicschools.org`, 
`rhernandez2@intrinsicschools.org`, 
`rdagley@intrinsicschools.org`, 
`schishti@intrinsicschools.org`, 
`sqasemi@intrinsicschools.org`, 
`sagoranos@intrinsicschools.org`, 
`tpatterson@intrinsicschools.org`, 
`tbrickey@intrinsicschools.org`, 
`tsmith@intrinsicschools.org`, 
`tmaxwell@intrinsicschools.org`, 
`tmuth@intrinsicschools.org`, 
`vrogers@intrinsicschools.org`, 
`ajambor@intrinsicschools.org`, 
`ameek@intrinsicschools.org`, 
`scalgtrig@intrinsicschools.org`, 
`ajohnson4@intrinsicschools.org`, 
`aogunniyi@intrinsicschools.org`, 
`9thbiology@intrinsicschools.org`, 
`bpersaud@intrinsicschools.org`, 
`dgarcia3@intrinsicschools.org`, 
`dveljkovic@intrinsicschools.org`, 
`dmosby@intrinsicschools.org`, 
`gmiradiaz@intrinsicschools.org`, 
`gsuarez@intrinsicschools.org`, 
`ilinton@intrinsicschools.org`, 
`kshattuck@intrinsicschools.org`, 
`kmatt@intrinsicschools.org`, 
`kpries@intrinsicschools.org`, 
`lhinton@intrinsicschools.org`, 
`lfisher@intrinsicschools.org`, 
`lizbethramales@intrinsicschools.org`, 
`mrhoades@intrinsicschools.org`, 
`msaenz1@intrinsicschools.org`, 
`mtexin@intrinsicschools.org`, 
`melissaokumura@intrinsicschools.org`, 
`michaelcarson@intrinsicschools.org`, 
`mirandagentry@intrinsicschools.org`, 
`pbowen@intrinsicschools.org`, 
`ropiocotto@intrinsicschools.org`, 
`rmitrovich@intrinsicschools.org`, 
`12thseminar@intrinsicschools.org`, 
`11thseminar@intrinsicschools.org`, 
`spanishIII@intrinsicschools.org`, 
`sped5@intrinsicschools.org`, 
`twillingham@intrinsicschools.org`, 
`tiffanywoods@intrinsicschools.org`, 
`vsouza@intrinsicschools.org`, 
`valvarez2@intrinsicschools.org`, 
`wblackman@intrinsicschools.org`, 
`12elasped@intrinsicschools.org`, 
`scmathplaceholder@intrinsicschools.org`, 
`biochem@intrinsicschools.org`, 
`cathleencarmen@intrinsicschools.org`, 
`9thelasped@intrinsicschools.org`, 
`gquijada@intrinsicschools.org`, 
`ililly@intrinsicschools.org`, 
`jdaar@intrinsicschools.org`, 
`jsancen@intrinsicschools.org`, 
`kmoore2@intrinsicschools.org`, 
`kbello@intrinsicschools.org`, 
`mbaum@intrinsicschools.org`, 
`mdelgado1@intrinsicschools.org`, 
`mconcepcion@intrinsicschools.org`, 
`mikaelladallal@intrinsicschools.org`, 
`nmiller@intrinsicschools.org`, 
`rbates@intrinsicschools.org`, 
`rsanchez@intrinsicschools.org`, 
`saahithimaturi@intrinsicschools.org`, 
`scastillo@intrinsicschools.org`, 
`sfountain@intrinsicschools.org`, 
`smarshall@intrinsicschools.org`, 
`vberto@intrinsicschools.org`, 
`12mathsped@intrinsicschools.org`, 
`asigala@intrinsicschools.org`, 
`brittanieburgin@intrinsicschools.org`, 
`bdavis@intrinsicschools.org`, 
`12thchemistry@intrinsicschools.org`, 
`dsamuels@intrinsicschools.org`, 
`ddadekian@intrinsicschools.org`, 
`jbenson@intrinsicschools.org`, 
`mpayne@intrinsicschools.org`, 
`madhulikagarimella@intrinsicschools.org`, 
`marvizu@intrinsicschools.org`, 
`12thmathsped@intrinsicschools.org`, 
`10thmathsped@intrinsicschools.org`, 
`7thmathsped@intrinsicschools.org`, 
`8thmathsped@intrinsicschools.org`, 
`npheteau@intrinsicschools.org`, 
`nathanielpalmer@intrinsicschools.org`, 
`smachotka@intrinsicschools.org`, 
`sperez4@intrinsicschools.org`, 
`transcend@intrinsicschools.org`, 
`dsmith1@intrinsicschools.org`, 
`jkaminsky@intrinsicschools.org`, 
`kristopheralejo@intrinsicschools.org`, 
`christopherford@intrinsicschools.org`, 
`spanish1@intrinscischools.org`, 
`9thhumplaceholder@intrinsicschools.org`, 
`9math@intrinsicschools.org`, 
`sruss@intrinsicschools.org`, 
`abotello@intrinsicschools.org`, 
`agandhi@intrinsicschools.org`, 

`amargelewski@intrinsicschools.org`, 
`avancea@intrinsicschools.org`, 
`btaylor@intrinsicschools.org`, 
`choulihan@intrinsicschools.org`, 
`test@test.com`, 
`imolnar@intrinsicschools.org`, 
`koria@intrinsicschools.org`, 
`mbaplugins@intrinsicschools.org`, 
`mangellotti@intrinsicschools.org`, 
`spuchalski@intrinsicschools.org`, 
`tligue@intrinsicschools.org`, 
`vpowell@intrinsicschools.org`, 
`zedwards@intrinsicschools.org`, 
`andy.black@powerschool.com`, 
`blabarge@intrinsicschools.org`, 
`callen@intrinsicschools.org`, 
`eporter@intrinsicschools.org`, 
`esmith1@intrinsicschools.org`, 
`eestrada@intrinsicschools.org`, 
`isbesisadmin@intrinsicschools.org`, 
`jbanks@intrinsicschools.org`, 
`jgracia@intrinsicschools.org`, 
`jvargas2@intrinsicschools.org`, 
`jtolman@intrinsicschools.org`, 
`jserrano@intrinsicschools.org`, 
`kbrennan@intrinsicschools.org`, 
`kbujak@intrinsicschools.org`, 
`kkreider@intrinsicschools.org`, 
`lmcghee@intrinsicschools.org`, 
`lweatherly@intrinsicschools.org`, 
`lcarmona2@intrinsicschools.org`, 
`mlandsdown@intrinsicschools.org`, 
`msalchert@intrinsicschools.org`, 
`mpencheva@intrinsicschools.org`, 
`mwalsh@intrinsicschools.org`, 
`mquiles@intrinsicschools.org`, 
`ncrumley@intrinsicschools.org`, 
`pjulion@intrinsicschools.org`, 
`phayes@intrinsicschools.org`, 
`postsecondary@intrinsicschools.org`, 
`rponce@intrinsicschools.org`, 
`ranaya@intrinsicschools.org`, 
`rshea@intrinsicschools.org`, 
`reverett@intrinsicschools.org`, 
`smoses@intrinsicschools.org`, 
`scarbone@intrinsicschools.org`, 
`smcguire@intrinsicschools.org`, 
`tbennett@intrinsicschools.org`, 
`tjackson@intrinsicschools.org`, 
`ygardner@intrinsicschools.org`, 
`aroman2@intrinsicschools.org`, 
`aguerra6@intrinsicschools.org`, 
`brodgers@intrinsicschools.org`, 
`bpodell@intrinsicschools.org`, 
`cgradilla@intrinsicschools.org`, 
`cpaar@intrinsicschools.org`, 
`cfett@intrinsicschools.org`, 
`cbrown2@intrinsicschools.org`, 
`clin@intrinsicschools.org`, 
`cschroeder@intrinsicschools.org`, 
`cschmit@intrinsicschools.org`, 
`dadams@intrinsicschools.org`, 
`drobles@intrinsicschools.org`, 
`djohnson@intrinsicschools.org`, 
`dcarmona2@intrinsicschools.org`, 
`dhahn@intrinsicschools.org`, 
`dgordon@intrinsicschools.org`, 
`dmartin@intrinsicschools.org`, 
`evillarreal@intrinsicschools.org`, 
`ekifarkis@intrinsicschools.org`, 
`eherrera2@intrinsicschools.org`, 
`gtagler@intrinsicschools.org`, 
`hgiannone@intrinsicschools.org`, 
`hstoecker@intrinsicschools.org`, 
`hkovac@intrinsicschools.org`, 
`imcfadden@intrinsicschools.org`, 
`izhang@intrinsicschools.org`, 
`jhernandez6@intrinsicschools.org`, 
`jcarbone@intrinsicschools.org`, 
`jcain@intrinsicschools.org`, 
`jmerida@intrinsicschools.org`, 
`jhames@intrinsicschools.org`, 
`jduarte@intrinsicschools.org`, 
`kparks2@intrinsicschools.org`, 
`kandres@intrinsicschools.org`, 
`kmurphy@intrinsicschools.org`, 
`kseeley@intrinsicschools.org`, 
`kocampo2@intrinsicschools.org`, 
`kgalmiche@intrinsicschools.org`, 
`kjacobs@intrinsicschools.org`, 
`kmccoy@intrinsicschools.org`, 
`kmoore3@intrinsicschools.org`, 
`lpaynter@intrinsicschools.org`, 
`lbroderick@intrinsicschools.org`, 
`llara2@intrinsicschools.org`, 
`mcondus@intrinsicschools.org`, 
`mcortezlopez@intrinsicschools.org`, 
`mjackson2@intrinsicschools.org`, 
`mhollander@intrinsicschools.org`, 
`mmork@intrinsicschools.org`, 
`mmiklosz@intrinsicschools.org`, 
`nbyrne@intrinsicschools.org`, 
`ocarmona@intrinsicschools.org`, 
`pbaez@intrinsicschools.org`, 
`pjohnson@intrinsicschools.org`, 
`prodriguez@intrinsicschools.org`, 
`rrobertson@intrinsicschools.org`, 
`rakam@intrinsicschools.org`, 
`rordiales@intrinsicschools.org`, 
`scucco@intrinsicschools.org`, 
`sweinstein@intrinsicschools.org`, 
`smyers@intrinsicschools.org`, 
`tridgeway@intrinsicschools.org`, 
`ajoseph@intrinsicschools.org`, 
`asaldana@intrinsicschools.org`, 
`askordilis@intrinsicschools.org`, 
`alaabs@intrinsicschools.org`, 
`athomas@intrinsicschools.org`, 
`apoindexter@intrinsicschools.org`, 
`amartinez6@intrinsicschools.org`, 
`azirk@intrinsicschools.org`, 
`aealy@intrinsicschools.org`, 
`asampson@intrinsicschools.org`, 
`amcintyre@intrinsicschools.org`, 
`bbrown@intrinsicschools.org`, 
`blee@intrinsicschools.org`, 
`cvargas@intrinsicschools.org`, 
`ckowalec@intrinsicschools.org`, 
`damatogoral@intrinsicschools.org`, 
`dcastanon1@intrinsicschools.org`, 
`dvillegasortega@intrinsicschools.org`, 
`dhuff@intrinsicschools.org`, 
`eryu@intrinsicschools.org`, 
`esimon@intrinsicschools.org`, 
`ecruz2@intrinsicschools.org`, 
`ebaggett@intrinsicschools.org`, 
`eporter1@intrinsicschools.org`, 
`gauguste@intrinsicschools.org`, 
`gmusco@intrinsicschools.org`, 
`hlee@intrinsicschools.org`, 
`honorsph@intrinsicschools.org`, 
`jgeorge@intrinsicschools.org`, 
`jsalgado2@intrinsicschools.org`, 
`jpaulino@intrinsicschools.org`, 
`jbecker@intrinsicschools.org`, 
`jsorem@intrinsicschools.org`, 
`jcross@intrinsicschools.org`, 
`jgill@intrinsicschools.org`, 
`jcaterino@intrinsicschools.org`, 
`kchavez2@intrinsicschools.org`, 
`kbenitez2@intrinsicschools.org`, 
`kjohnson2@intrinsicschools.org`, 
`kboyd@intrinsicschools.org`, 
`lteague@intrinsicschools.org`, 
`lvalane@intrinsicschools.org`, 
`lamador1@intrinsicschools.org`, 
`malcozer@intrinsicschools.org`, 
`mstates@intrinsicschools.org`, 
`margueta1@intrinsicschools.org`, 
`mrivera5@intrinsicschools.org`, 
`mavalos@intrinsicschools.org`, 
`mperry@intrinsicschools.org`, 
`mmadson@intrinsicschools.org`, 
`nbuskirk@intrinsicschools.org`, 
`nelman@intrinsicschools.org`, 
`ndoble@intrinsicschools.org`, 
`rfeldman@intrinsicschools.org`, 
`rstephens@intrinsicschools.org`, 
`rpadilla@intrinsicschools.org`, 
`snaser@intrinsicschools.org`, 
`sgates@intrinsicschools.org`, 
`sheimbuck@intrinsicschools.org`, 
`stalos@intrinsicschools.org`, 
`tmock@intrinsicschools.org`, 
`tgardner@intrinsicschools.org`, 
`tzaino@intrinsicschools.org`, 
`vsalgado@intrinsicschools.org`, 
`yvelazquez@intrinsicschools.org`, 
`zothman@intrinsicschools.org`, 
`abruiz@intrinsicschools.org`, 
`apater@intrinsicschools.org`, 
`cryan@intrinsicschools.org`, 
`cmuhammad@intrinsicschools.org`, 
`dbroomfield@intrinsicschools.org`, 
`dades@intrinsicschools.org`, 
`eabreu@intrinsicschools.org`, 
`gespinoza@intrinsicschools.org`, 
`jescamilla@intrinsicschools.org`, 
`joaks@intrinsicschools.org`, 
`jhart@intrinsicschools.org`, 
`jellison@intrinsicschools.org`, 
`jdowdy@intrinsicschools.org`, 
`lreese@intrinsicschools.org`, 
`msmith@intrinsicschools.org`, 
`mraffenetti@intrinsicschools.org`, 
`mpeters@intrinsicschools.org`, 
`mmarcial@intrinsicschools.org`, 
`mcorzo@intrinsicschools.org`, 
`mgadau@intrinsicschools.org`, 
`mcortez2@intrinsicschools.org`, 
`mcoleman@intrinsicschools.org`, 
`mbrantley@intrinsicschools.org`, 
`ncruz@intrinsicschools.org`, 
`nkaminsky@intrinsicschools.org`, 
`pford@intrinsicschools.org`, 
`pcabe@intrinsicschools.org`, 
`pvarnado@intrinsicschools.org`, 
`rrozen@intrinsicschools.org`, 
`rhernandez@intrinsicschools.org`, 
`smctier@intrinsicschools.org`, 
`tjimenez@intrinsicschools.org`, 
`araqeeb@puredata.io`, 
`tparham@intrinsicschools.org`, 
`tkoumbis@intrinsicschools.org`, 
`tstanford@intrinsicschools.org`, 
`twhittington@intrinsicschools.org`, 
`tchavez@intrinsicschools.org`, 
`Unknown`, 
`vsantiago@intrinsicschools.org`, 
`vlove@intrinsicschools.org`, 
`vsanpablo@intrinsicschools.org`, 
`zmartinez@intrinsicschools.org`, 
`aestrada@intrinsicschools.org`, 
`bmason@intrinsicschools.org`, 
`bharris@intrinsicschools.org`, 
`ccruz1@intrinsicschools.org`, 
`cokoro@intrinsicschools.org`, 
`cjardon@intrinsicschools.org`, 
`ckelly@intrinsicschools.org`, 
`dmarino@intrinsicschools.org`, 
`dflowers@intrinsicschools.org`, 
`dcordell@intrinsicschools.org`, 
`erodriguez@intrinsicschools.org`, 
`gvasquez1@intrinsicschools.org`, 
`hgill@intrinsicschools.org`, 
`hsaldana@intrinsicschools.org`, 
`jorozco1@intrinsicschools.org`, 
`jkurian@intrinsicschools.org`, 
`jatkin@intrinsicschools.org`, 
`jvega@intrinsicschools.org`, 
`jwood@intrinsicschools.org`, 
`jmiranda4@intrinsicschools.org`, 
`kvillanueva@intrinsicschools.org`, 
`mrobinson@intrinsicschools.org`, 
`mhughes@intrinsicschools.org`, 
`mgolonka@intrinsicschools.org`, 
`mtrojan@intrinsicschools.org`, 
`othomas@intrinsicschools.org`, 
`student_success_accounts+intrinsic@panoramaed.com`, 
`pking@intrinsicschools.org`, 
`rnavestawasz@intrinsicschools.org`, 
`sli1@intrinsicschools.org`, 
`snunn@intrinsicschools.org`, 
`sadams@intrinsicschools.org`, 
`tparianos@intrinsicschools.org`, 
`tkahn@intrinsicschools.org`, 
`zwilliams@intrinsicschools.org`, 
`acarbajal3@intrinsicschools.org`, 
`avega2@intrinsicschools.org`, 
`atkachuk@intrinsicschools.org`, 
`bhill@intrinsicschools.org`, 
`chellmann@intrinsicschools.org`, 
`cmay@intrinsicschools.org`, 
`cbellamy@intrinsicschools.org`, 
`eobrzut@intrinsicschools.org`, 
`efunk@intrinsicschools.org`, 
`gmizgala@intrinsicschools.org`, 
`gramirez1@intrinsicschools.org`, 
`chalk@intrinsicschools.org`, 
`reports@intrinsicschools.org`, 
`jmusich@intrinsicschools.org`, 
`kgunty@intrinsicschools.org`, 
`mstarr@intrinsicschools.org`, 
`pgomez@intrinsicschools.org`, 
`switte@intrinsicschools.org`, 
`sgamboa@intrinsicschools.org`, 
`efrantzen@intrinsicschools.org`, 
`jsandiego@intrinsicschools.org`, 
  ]

  exports.staff_emails = staff_emails